import { Button, Search } from '@ibsys/kit';
import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormGuardActions } from '@/entities/formGuard';
import { useHasPermission } from '@/entities/profile';
import { MasterDetailLayout } from '@/shared/ui';
import { OntologyList } from './ui/OntologyList';
import { OntologyFormSection } from './ui/OntologyFormSection';

/**
 * Страница «Модель знаний»: двухпанельное управление типами сущностей онтологии.
 */
export const OntologyPage: FC = () => {
  const { t } = useTranslation(['common', 'ontology']);
  const navigate = useNavigate();
  const { code } = useParams<{ code?: string }>();
  const canAdmin = useHasPermission('ADMIN_KM_ENTITY_TYPE');
  const { setIsDirty } = useFormGuardActions();

  const [search, setSearch] = useState('');

  // Стабильный колбэк: иначе эффект синхронизации признака несохранённых изменений
  // перезапускается на каждый рендер и повторно взводит form-guard после сброса
  const handleUnsavedChange = useCallback((dirty: boolean) => setIsDirty(dirty), [setIsDirty]);

  const handleCreate = () => {
    navigate('/ontology/create');
  };

  const handleBack = () => {
    navigate('/ontology');
  };

  return (
    <MasterDetailLayout
      isDetailOpen={Boolean(code)}
      onBack={handleBack}
      toolbar={
        <div className="flex items-center gap-4">
          <Search
            className="flex-1"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t('common:search')}
          />
          {canAdmin && <Button onClick={handleCreate}>{t('ontology:addType')}</Button>}
        </div>
      }
      list={<OntologyList search={search} />}
      detail={<OntologyFormSection code={code} key={code} onUnsavedChange={handleUnsavedChange} />}
    />
  );
};
